import { render, staticRenderFns } from "./ChatComposer.vue?vue&type=template&id=e0a8df64&scoped=true"
import script from "./ChatComposer.vue?vue&type=script&lang=js"
export * from "./ChatComposer.vue?vue&type=script&lang=js"
import style0 from "./ChatComposer.vue?vue&type=style&index=0&id=e0a8df64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a8df64",
  null
  
)

export default component.exports